import { msg } from '@lingui/core/macro';
import { BackendErrorContext, getErrorReason } from 'shared/errors';
import type { MessageDescriptor } from 'shared/i18n';

/** Поле → контекст правил «по тексту» реестра (`shared/errors`): отказ валидатора — без кода. */
const SIGN_UP_FIELD_CONTEXT: Record<string, BackendErrorContext> = {
  phone: BackendErrorContext.SIGN_UP_PHONE,
};

/** Ответ сервера, у которого нет перевода: английский текст валидатора пользователю не показываем. */
export const SIGN_UP_UNKNOWN_FIELD_ERROR = msg`Проверьте значение поля`;

/** Известный ответ бэкенда на регистрацию → сообщение пользователю; неизвестный — `undefined`. */
export function getSignUpErrorMessage(field: string, serverMessage: string): MessageDescriptor | undefined {
  const context = SIGN_UP_FIELD_CONTEXT[field];
  return context ? getErrorReason({ message: serverMessage }, { context }) : undefined;
}
